"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.QUARK_ALERT = void 0;

var React = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var QUARK_ALERT = 'QUARK_ALERT';
exports.QUARK_ALERT = QUARK_ALERT;

function _default(_ref) {
  var config = _objectWithoutProperties(_ref, []);

  // the metadata for the event
  var detail = _extends({
    namespace: 'default',
    type: 'message'
  }, config, {
    id: new Date().getTime() // construct event with details

  });

  var alert = new CustomEvent(QUARK_ALERT, {
    detail: detail
  }); // dispatch event

  window.dispatchEvent(alert);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/alerts/trigger/index.js
// module id = ./node_modules/quark-web/components/alerts/trigger/index.js
// module chunks = 0